/* eslint-disable react/prop-types */

const fmt = (n) => (n ? new Intl.NumberFormat("vi-VN").format(n) : "");

export const getPrintTemplate = ({ headerInfo, rows, totals }) => {
  const rowsHtml = rows
    .map(
      (row) => `
      <tr>
        <td class="text-center">${row.orderNumber || ""}</td>
        <td>${row.assetNameAndSpecs || ""}</td>
        <td class="text-center">${row.assetCode || ""}</td>
        <td class="text-center">${row.assetCardNumber || ""}</td>
        <td class="text-right">${fmt(row.bookOriginalCost)}</td>
        <td class="text-right">${fmt(row.bookDepreciation)}</td>
        <td class="text-right">${fmt(row.bookRemainingValue)}</td>
        <td class="text-right">${fmt(row.revOriginalCost)}</td>
        <td class="text-right">${fmt(row.revDepreciation)}</td>
        <td class="text-right">${fmt(row.revRemainingValue)}</td>
        <td class="text-right">${fmt(row.diffOriginalCost)}</td>
        <td class="text-right">${fmt(row.diffDepreciation)}</td>
        <td class="text-right">${fmt(row.diffRemainingValue)}</td>
      </tr>
    `
    )
    .join("");

  const committeeHtml = headerInfo.committee
    .map(
      (member) =>
        `<div>- Ông/Bà: ${member.name} - Chức vụ: ${member.position} - Đại diện: ${member.representative} - ${member.role}</div>`
    )
    .join("");

  return `
    <html>
      <head>
        <title>In Biên Bản Đánh Giá Lại TSCĐ (Mẫu 04-TSCĐ)</title>
        <style>
          @media print {
            @page { margin: 15mm; size: A4 landscape; }
          }
          body {
            font-family: "Times New Roman", Times, serif;
            color: #000;
            padding: 20px;
            font-size: 12px;
            line-height: 1.3;
          }
          .header-top { display: flex; justify-content: space-between; margin-bottom: 15px; }
          .title-box { text-align: center; margin: 20px 0 30px 0; position: relative; }
          .title-main { font-size: 18px; font-weight: bold; margin: 0; text-transform: uppercase; }
          .right-info { position: absolute; right: 0; top: 25px; text-align: left; }
          .table-container { overflow-x: auto; margin: 20px 0; }
          table { width: 100%; border-collapse: collapse; font-size: 11px; }
          th, td { border: 1px solid #000; padding: 3px 5px; vertical-align: middle; }
          th { text-align: center; font-weight: bold; background-color: #f5f5f5; }
          .text-right { text-align: right; }
          .text-center { text-align: center; }
          .bold { font-weight: bold; }
          .footer { display: flex; justify-content: space-between; margin-top: 40px; text-align: center; font-size: 12px; }
          .footer-col { width: 33%; }
          .signature-line { border-bottom: 1px dotted #000; width: 150px; margin: 20px auto 0; text-align: center; padding-top: 50px; }
          .flex-row { display: flex; align-items: center; margin-bottom: 6px; }
          .committee-section { margin: 20px 0; }
          .conclusion-section { margin-top: 20px; }
          .conclusion-textarea { 
            width: 100%; 
            min-height: 60px; 
            border-bottom: 1px dotted #000; 
            background: transparent; 
            font-family: inherit; 
            font-size: 14px; 
            resize: vertical; 
            line-height: 1.5;
            padding: 5px;
          }
          .note-section { margin-top: 40px; font-size: 13px; padding-bottom: 20px; }
        </style>
      </head>
      <body onload="window.print()">
        <div class="header-top">
          <div style="width: 40%;">
            <div class="bold" style="margin-bottom: 5px;">
              Đơn vị: <span style="border-bottom: 1px dotted #000; min-width: 200px; display: inline-block;">${
                headerInfo.unit || ""
              }</span>
            </div>
            <div class="bold">
              Bộ phận: <span style="border-bottom: 1px dotted #000; min-width: 200px; display: inline-block;">${
                headerInfo.department || ""
              }</span>
            </div>
          </div>
          <div style="width: 60%; text-align: center;">
            <div class="bold">Mẫu số 04 - TSCĐ</div>
            <div style="font-style: italic; font-size: 12px; margin-top: 4px;">
              (Kèm theo Thông tư số 99/2025/TT-BTC <br />
              ngày 27 tháng 10 năm 2025 của Bộ trưởng Bộ Tài chính)
            </div>
          </div>
        </div>

        <div class="title-box">
          <h2 class="title-main">BIÊN BẢN ĐÁNH GIÁ LẠI TSCĐ</h2>
          <div style="font-style: italic; margin-top: 8px;">
            Ngày <span style="border-bottom: 1px dotted #000; width: 40px; display: inline-block; text-align: center;">${
              headerInfo.revDay || ""
            }</span> tháng 
            <span style="border-bottom: 1px dotted #000; width: 40px; display: inline-block; text-align: center; margin: 0 4px;">${
              headerInfo.revMonth || ""
            }</span> 
            năm <span style="border-bottom: 1px dotted #000; width: 60px; display: inline-block; text-align: center;">${
              headerInfo.revYear || ""
            }</span> ...
          </div>
          <div class="right-info">
            <div style="margin-bottom: 4px;">
              Số: <span style="border-bottom: 1px dotted #000; width: 100px; display: inline-block;">${
                headerInfo.documentNumber || ""
              }</span>
            </div>
            <div style="margin-bottom: 4px;">
              Nợ: <span style="border-bottom: 1px dotted #000; width: 100px; display: inline-block;">${
                headerInfo.debitAccount || ""
              }</span>
            </div>
            <div>
              Có: <span style="border-bottom: 1px dotted #000; width: 100px; display: inline-block;">${
                headerInfo.creditAccount || ""
              }</span>
            </div>
          </div>
        </div>

        <div style="margin: 30px 0 20px 0;">
          <div style="margin-bottom: 10px;">
            Căn cứ Quyết định số: <span style="border-bottom: 1px dotted #000; width: 150px; display: inline-block;">${
              headerInfo.decisionNumber || ""
            }</span> ngày 
            <span style="border-bottom: 1px dotted #000; width: 40px; display: inline-block; text-align: center; margin: 0 4px;">${
              headerInfo.decisionDay || ""
            }</span> tháng 
            <span style="border-bottom: 1px dotted #000; width: 40px; display: inline-block; text-align: center; margin: 0 4px;">${
              headerInfo.decisionMonth || ""
            }</span> năm 
            <span style="border-bottom: 1px dotted #000; width: 60px; display: inline-block; text-align: center;">${
              headerInfo.decisionYear || ""
            }</span> ...
          </div>
          <div style="margin-bottom: 15px;">
            Của <span style="border-bottom: 1px dotted #000; width: 250px; display: inline-block;">${
              headerInfo.decisionMaker || ""
            }</span> Về việc đánh giá lại <span style="text-decoration: underline; font-weight: bold;">TSCĐ</span>
          </div>
          
          <div class="committee-section">
            <div style="margin-bottom: 10px; font-weight: bold;">Hội đồng đánh giá lại gồm:</div>
            ${committeeHtml}
          </div>
          
          <div style="margin-top: 20px; font-weight: bold;">
            Đã thực hiện đánh giá lại giá trị các TSCĐ sau đây:
          </div>
        </div>

        <div class="table-container">
          <table>
            <thead>
              <tr>
                <th rowspan="2" style="width: 40px;">STT</th>
                <th rowspan="2" style="width: 160px;">Tên, ký hiệu, quy cách TSCĐ</th>
                <th rowspan="2" style="width: 60px;">Số hiệu TSCĐ</th>
                <th rowspan="2" style="width: 60px;">Số thẻ TSCĐ</th>
                <th colspan="3">Giá trị ghi sổ</th>
                <th colspan="3">Giá trị đánh giá lại</th>
                <th colspan="3">Chênh lệch</th>
              </tr>
              <tr>
                <th>Nguyên giá</th>
                <th>Hao mòn</th>
                <th>Giá trị còn lại</th>
                <th>Nguyên giá</th>
                <th>Hao mòn</th>
                <th>Giá trị còn lại</th>
                <th>Nguyên giá</th>
                <th>Hao mòn</th>
                <th>Giá trị còn lại</th>
              </tr>
              <tr style="background-color: #fafafa;">
                <th>A</th>
                <th>B</th>
                <th>C</th>
                <th>D</th>
                <th>1</th>
                <th>2</th>
                <th>3</th>
                <th>4</th>
                <th>5</th>
                <th>6</th>
                <th>7</th>
                <th>8</th>
                <th>9</th>
              </tr>
            </thead>
            <tbody>
              ${rowsHtml}
              <tr style="font-weight: bold; background-color: #fff;">
                <td colspan="4" class="text-center">Cộng (-)</td>
                <td class="text-right">${fmt(totals.bookOriginalCost)}</td>
                <td class="text-right">${fmt(totals.bookDepreciation)}</td>
                <td class="text-right">${fmt(totals.bookRemainingValue)}</td>
                <td class="text-right">${fmt(totals.revOriginalCost)}</td>
                <td class="text-right">${fmt(totals.revDepreciation)}</td>
                <td class="text-right">${fmt(totals.revRemainingValue)}</td>
                <td class="text-right">${fmt(totals.diffOriginalCost)}</td>
                <td class="text-right">${fmt(totals.diffDepreciation)}</td>
                <td class="text-right">${fmt(totals.diffRemainingValue)}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="conclusion-section">
          <div style="font-weight: bold; margin-top: 25px;">Kết luận:</div>
          <div style="border-bottom: 1px dotted #000; min-height: 60px; padding: 5px; margin-top: 5px;">
            ${
              headerInfo.conclusion ||
              "...................................................................................................................................................."
            }
          </div>
        </div>

        <div class="footer">
          <div class="footer-col">
            <div class="bold">Ủy viên/người lập</div>
            <div style="font-style: italic; font-size: 12px; margin-bottom: 65px;">(Ký, họ tên)</div>
            <div class="signature-line">${headerInfo.creatorName || ""}</div>
          </div>
          <div class="footer-col">
            <div class="bold">Kế toán trưởng</div>
            <div style="font-style: italic; font-size: 12px; margin-bottom: 65px;">(Ký, họ tên)</div>
            <div class="signature-line">${headerInfo.accountantName || ""}</div>
          </div>
          <div class="footer-col">
            <div style="font-style: italic; margin-bottom: 10px;">
              Ngày ${
                headerInfo.signingDate ? new Date(headerInfo.signingDate).getDate() : "..."
              } tháng 
              ${
                headerInfo.signingDate ? new Date(headerInfo.signingDate).getMonth() + 1 : "..."
              } năm 
              ${headerInfo.signingDate ? new Date(headerInfo.signingDate).getFullYear() : "..."}
            </div>
            <div class="bold">Chủ tịch Hội đồng</div>
            <div style="font-style: italic; font-size: 12px; margin-bottom: 45px;">(Ký, họ tên)</div>
            <div class="signature-line">${headerInfo.headOfCommitteeName || ""}</div>
          </div>
        </div>

        <div class="note-section">
          <b>Ghi chú:</b> <i style="text-decoration: underline;">Tùy</i> <i style="font-style: italic;">
            theo đặc điểm hoạt động sản xuất kinh doanh và yêu cầu quản lý của đơn vị mình, doanh nghiệp 
            được xây dựng, thiết kế biểu mẫu chứng từ kế toán.
          </i>
        </div>
      </body>
    </html>
  `;
};
